
import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
// import FancyRadio, { RadioType, OptionType } from './FancyRadio';
// import Checkbox  from '@mui/joy/Checkbox';
import RadioGroup from '@mui/joy/RadioGroup';
import Radio from '@mui/joy/Radio';
import FormHelperText from '@mui/joy/FormHelperText';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';
import useDedicatedAssignment from 'hooks/useDedicatedAssignment';
// import { getIcon } from 'utils/misc';
import useAuth from 'hooks/useAuth';
import useUserIdentity from 'hooks/useUserIdentity';

import { LoreDecorator }  from 'components/Lore';

type InviteSelectorProps = {
    setValue: (s: string) => void,
    selectedValue: string,
    hideDayOnes?: boolean,
    hideDedicated?: boolean,
    hideJustMe?: boolean
}

const CollabCreateInviteSelector = observer(({setValue, selectedValue, hideDayOnes=false, hideDedicated=false, hideJustMe=false}: InviteSelectorProps) =>{

    const { currentUser } = useAuth();
    const { currentIdentity } = useUserIdentity();

    const { hasDedicatedAssistant } = useDedicatedAssignment();

    useEffect(() => {
        if (selectedValue == 'initial') {
            if (hasDedicatedAssistant(currentIdentity?.uuid)) {
                setValue('dedicated');
            }
            else if (currentUser.current_credit > 0) {
                setValue('day-ones');
            }
            else if (currentUser.tasks_remaining > 0) {
                setValue('standard-service');
            }
            else {
                setValue('private');
            }
        }
    }, [currentUser.tasks_remaining, currentUser.current_credit]);

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const v = (event.target as HTMLInputElement).value;
        setValue(v);
    }


    return (
        <Stack spacing={2}>
            <RadioGroup name="collab-invite">
            <Stack spacing={1}>


                    {!hideDedicated &&
                        <Stack>
                            <Tooltip
                                placement="top-start"
                                title="Send this directly to your Dedicated Assistant. This will use Minutes">
                                <Radio
                                    checked={selectedValue === "dedicated"}
                                    value="dedicated"
                                    label="Dedicated Assistant"
                                    onChange={handleChange}
                                />
                            </Tooltip>
                            <FormHelperText id="dedicated-text">
                                Send to your dedicated assistant.
                            </FormHelperText>
                        </Stack>
            }

                    { (!hideDayOnes && currentUser.current_credit > 0) &&
                    <Stack>
                        <Tooltip
                            placement="top-start"
                            title="Send this to the Day Ones service. This will use Minutes.">
                            <Radio
                                checked={selectedValue === "day-ones"}
                                value="day-ones"
                                label="Day Ones"
                                onChange={handleChange}
                            />
                        </Tooltip>
                        <FormHelperText id="day-ones-text">
                            We'll find a great person and get started right away.
                        </FormHelperText>
                    </Stack> }


                    {currentUser.tasks_remaining > 0 &&
                        <Stack>
                            <Tooltip
                                placement="top-start"
                                title="The original Fancy Hands service with a new coat of paint. This will use requests.">
                                <Radio
                                    checked={selectedValue === "standard-service"}
                                    onChange={handleChange}
                                    value="standard-service"
                                    label="Standard Service"
                                />
                            </Tooltip>
                            <FormHelperText id="dedicated-text">
                                Send this to the original, request-based, Fancy Hands service.
                            </FormHelperText>
                        </Stack>
                    }

                    {hideDedicated &&
                        <Stack>
                            <Tooltip
                                placement="top-start"
                                title="Send this directly to your Dedicated Assistant. This will use Minutes">
                                <Radio disabled
                                    checked={selectedValue === "dedicated"}
                                    value="dedicated"
                                    label="Dedicated Assistant"
                                    onChange={handleChange}
                                />
                            </Tooltip>
                            <FormHelperText id="dedicated-text">
                                <Typography
                                                                    endDecorator={<LoreDecorator slug={"feature/dedicated/info"} />}>Send to your dedicated assistant.</Typography>
                            </FormHelperText>
                        </Stack>
                    }


                    { !hideJustMe &&
                    <Stack>
                        <Tooltip
                            placement="top-start"
                            title="Work alone for now. You can invite another person later. This does not use Credits or Minutes.">
                            <Radio
                                onChange={handleChange}
                                checked={selectedValue === "private"}
                                value="private"
                                label="Just Me"
                            />
                        </Tooltip>
                        <FormHelperText id="private-text">
                            <Stack spacing={1}>
                                <Stack>
                                    Work on this alone for now.
                                </Stack>

                            </Stack>
                        </FormHelperText>
                    </Stack>
                    }
                </Stack>
            </RadioGroup>

            { !hideDayOnes &&
            <Typography level="body-sm">
                You can invite more collaborators at any time.
            </Typography>
            }
                </Stack>
    );
    // const radio = {
    //     label: "Invite someone now?",
    //     name: "initial_invite",
    //     value: selectedValue,
    //     setValue: setValue,
    //     helper: "Should we find someone to work on this now?",
    //     icon: <InviteIcon />,
    // } as RadioType;

    // const options = [
    //     { value: 'now',
    //         text: 'Now',
    //         helper: "We'll find the right person and get started right away (Day Ones)",
    //         recommended: true,
    //         icon: <Now />,
    //     } as OptionType,
    //     { value: 'later',
    //         text: 'Later',
    //         helper: "Save this, but don't invite anyone yet.",
    //         icon: <Later />
    //     } as OptionType,
    //     { value: 'dedicated',
    //         text: 'Dedicated',
    //         helper: "Send it to your dedicated assistant",
    //         disabled: !showDedicated,
    //         icon: <Dedicated />
    //     } as OptionType,
    //     { value: 'specific',
    //         text: 'Mutual',
    //         helper: "Invite someone specifically",
    //         disabled: true,
    //         icon: <Mutual />
    //     } as OptionType,
    // ];

    // return <FancyRadio radio={radio} options={options}/>;
});

export default CollabCreateInviteSelector;
